/** Max height (px) of the scrollable arrivals list inside the stop popup. */
export const STOP_POPUP_ARRIVALS_LIST_MAX_HEIGHT_PX = 325;

/**
 * Fixed height (px) of the arrivals list shell.
 * Skeleton and loaded rows share this box so the popup shell does not resize between phases.
 */
export const STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX = STOP_POPUP_ARRIVALS_LIST_MAX_HEIGHT_PX;

/** Estimated chrome above the arrivals list (header, borders, body padding). */
export const STOP_POPUP_CHROME_HEIGHT_ESTIMATE_PX = 52;

/**
 * Fallback total popup height (px) before the first layout measure.
 * Must include {@link STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX}, not replace it.
 */
export const STOP_POPUP_FALLBACK_TOTAL_HEIGHT_PX =
    STOP_POPUP_CHROME_HEIGHT_ESTIMATE_PX + STOP_POPUP_ARRIVALS_LIST_FIXED_HEIGHT_PX;

/**
 * Skeleton rows rendered during load.
 * Clipped at {@link STOP_POPUP_ARRIVALS_LIST_MAX_HEIGHT_PX} to mirror a full list
 * (several complete rows plus one partial peek).
 */
export const STOP_POPUP_LOADING_SKELETON_ROW_COUNT = 5;

/** Tailwind classes shared by real arrival chips and skeleton placeholders. */
export const STOP_POPUP_ARRIVAL_CHIP_CLASS_NAME = "rounded-xl border px-2 py-1 space-y-1";

/** Min width (px) of the route short-name badge in an arrival chip. */
export const STOP_POPUP_ARRIVAL_ROUTE_BADGE_MIN_WIDTH_PX = 40;

/** Route short-name badge shell shared by real rows and skeleton rows. */
export const STOP_POPUP_ARRIVAL_ROUTE_BADGE_CLASS_NAME =
    "px-3 py-[1px] rounded-full font-bold text-sm flex-shrink-0 text-center border border-ionic-primary";

/** Top icon + route badge + headsign block inside an arrival chip. */
export const STOP_POPUP_ARRIVAL_MAIN_ROW_CLASS_NAME = "flex items-center gap-1";

/** Headsign line above the operator / quai sub-row. */
export const STOP_POPUP_ARRIVAL_HEADSIGN_CLASS_NAME = "font-bold text-sm truncate";

/** Per-arrival quai badge shell on parent-station rows. */
export const STOP_POPUP_ARRIVAL_PER_ARRIVAL_QUAI_BADGE_CLASS_NAME =
    "text-xs font-semibold rounded border";

/**
 * Invisible per-arrival quai slot.
 * Keeps the operator row aligned on a parent stop when the departure has no platform yet.
 */
export const STOP_POPUP_ARRIVAL_PER_ARRIVAL_QUAI_PLACEHOLDER_CLASS_NAME =
    "inline-flex flex-shrink-0 items-center rounded border border-transparent px-2 py-0.5 text-xs opacity-0";


/** Bus / tram countdown + clock time row below the route divider. */
export const STOP_POPUP_ARRIVAL_TIME_ROW_CLASS_NAME = "flex items-center gap-2 flex-wrap text-sm";

/** Train arrival time pill below the route divider (no countdown min-height). */
export const STOP_POPUP_ARRIVAL_TRAIN_TIME_PILL_CLASS_NAME =
    "inline-flex items-center gap-2 flex-wrap max-w-full rounded-full border px-2.5 py-1 text-sm";

/** Minutes / imminent value slot inside the countdown pill. */
export const STOP_POPUP_COUNTDOWN_PILL_VALUE_CLASS_NAME =
    "inline-flex h-4 w-7 shrink-0 items-center justify-center self-center font-medium tabular-nums leading-none";

/**
 * Row spacing applied on the motion shell (not flex gap) so exit can collapse
 * height and margin in one continuous motion.
 */
export const STOP_POPUP_ARRIVAL_ROW_SPACING_CLASS_NAME = "mb-1.5 shrink-0";

/** Tailwind classes shared by bus countdown / train time pills and skeleton pills. */
export const STOP_POPUP_ARRIVAL_TIME_PILL_CLASS_NAME =
    "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 min-h-7 flex-shrink-0";

/**
 * Operator / per-arrival quai sub-row inside an arrival chip.
 * Fixed min-height keeps row height stable whether the quai badge is present or not.
 */
export const STOP_POPUP_ARRIVAL_SUPPLIER_ROW_CLASS_NAME =
    "flex min-h-5 items-center justify-between gap-2";

/**
 * Stop popup title bar.
 * Min-height keeps the header stable when the global quai badge is present or absent.
 */
export const STOP_POPUP_HEADER_CLASS_NAME =
    "px-2 py-2 font-bold text-sm flex min-h-9 items-center gap-2 min-w-0";
